import React from 'react';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingsSectionRow,
  SettingToggle,
} from '@views/Settings/components';
import styles from './Emails.module.scss';
import useEnabledNotifications from '../use-enabled-notifications';

export default function Emails() {
  const { enabledNotifications, toggleNotification } = useEnabledNotifications();

  return (
    <Section>
      <SettingsSectionLabel>Emails</SettingsSectionLabel>
      <SettingsSectionBox>
        <SettingsSectionRow className={styles.report}>
          <SettingToggle
            title="Weekly Digest"
            checked={enabledNotifications['weekly_digest']}
            name="weekly_digest"
            onChange={() => toggleNotification('weekly_digest')}
          />
          <p>Receive a curated summary of activity in Clay every Sunday evening.</p>
        </SettingsSectionRow>
        <SettingsSectionRow className={styles.report}>
          <SettingToggle
            title="Daily Brief"
            checked={enabledNotifications['daily_brief']}
            name="daily_brief"
            onChange={() => toggleNotification('daily_brief')}
          />
          <p>Receive a curated brief of the people you're meeting today, sent each morning.</p>
        </SettingsSectionRow>
      </SettingsSectionBox>
    </Section>
  );
}
